/// <reference path="api.d.ts" />

namespace API.Client {
    'use strict';

    export interface BranchesRS {

        "branches"?: Array<Branch>;
    }

}
